export class RuleModel {
  public id: number;
  public code: string;
  public name: string;
  public type: string;
  public value: string|number;
  public initValue: Array<string|number>;
  public defaultValue: string = '';
  public createdAt?: string;
  public updatedAt?: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.code = data.code;
    this.name = data.name;
    this.type = data.type;
    this.value = data.value;
    this.initValue = data.initValue || [];
    this.defaultValue = '';
  }

  public mapData(data: any = {}) {
    this.id = data.id;
    this.code = data.code;
    this.name = data.name;
    this.type = data.type;
    this.value = data.value;
    if (this.type === 'number') {
      this.value = Number(this.value);
    }
    this.defaultValue = data.defaultValue;
    this.initValue = data.initValue;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
